import { LogLevel } from "@azure/msal-browser";

// Authentication configuration. See Azure AD Application registration for auth values.
const msalConfig = {
    auth: {
        clientId: process.env.REACT_APP_AUTH_CLIENT_ID,
        authority: process.env.REACT_APP_AUTH_AUTHORITY,
        redirectUri: process.env.REACT_APP_AUTH_REDIRECT_URI,
        postLogoutRedirectUri: process.env.REACT_APP_AUTH_POST_LOGOUT_URI
    },
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: false
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.log(message);
                        return;
                    case LogLevel.Info:
                        //console.log(message);
                        return;
                    case LogLevel.Verbose:
                        //console.log(message);
                        return;
                    case LogLevel.Warning:
                        console.log(message);
                        return;
                    default:
                        return;
                }
            }
        }
    }
};

// Set localhost redirect url
if (window.location.href.indexOf("localhost") !== -1) {
    msalConfig.auth.redirectUri = "http://localhost:3000/auth-response";
    msalConfig.auth.postLogoutRedirectUri = "http://localhost:3000";
};

export default msalConfig;